var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 7.25C5.22018 7.25 5.5 6.97018 5.5 6.625C5.5 6.27982 5.22018 6 4.875 6C4.52982 6 4.25 6.27982 4.25 6.625C4.25 6.97018 4.52982 7.25 4.875 7.25Z",
    fill: "#3F4752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 9.75C5.22018 9.75 5.5 9.47018 5.5 9.125C5.5 8.77982 5.22018 8.5 4.875 8.5C4.52982 8.5 4.25 8.77982 4.25 9.125C4.25 9.47018 4.52982 9.75 4.875 9.75Z",
    fill: "#3F4752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 12.25C5.22018 12.25 5.5 11.9702 5.5 11.625C5.5 11.2798 5.22018 11 4.875 11C4.52982 11 4.25 11.2798 4.25 11.625C4.25 11.9702 4.52982 12.25 4.875 12.25Z",
    fill: "#3F4752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.625C6.75 6.97019 7.02981 7.25 7.375 7.25H11.125C11.4702 7.25 11.75 6.97019 11.75 6.625C11.75 6.27981 11.4702 6 11.125 6H7.375C7.02981 6 6.75 6.27981 6.75 6.625Z",
    fill: "#3F4752"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 8.5H7.375C7.02981 8.5 6.75 8.77981 6.75 9.125C6.75 9.47019 7.02981 9.75 7.375 9.75H11.125C11.4702 9.75 11.75 9.47019 11.75 9.125C11.75 8.77981 11.4702 8.5 11.125 8.5Z",
    fill: "#3F4752"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 11H7.375C7.02981 11 6.75 11.2798 6.75 11.625C6.75 11.9702 7.02981 12.25 7.375 12.25H11.125C11.4702 12.25 11.75 11.9702 11.75 11.625C11.75 11.2798 11.4702 11 11.125 11Z",
    fill: "#3F4752"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 1.25C12.0298 1.25 11.75 1.52981 11.75 1.875C11.75 2.22019 12.0298 2.5 12.375 2.5C12.7196 2.5 13 2.78038 13 3.125V14.125C13 14.4696 12.7196 14.75 12.375 14.75H3.625C3.28038 14.75 3 14.4696 3 14.125V3.125C3 2.78038 3.28038 2.5 3.625 2.5H5.6075C5.8655 3.22744 6.56022 3.75 7.375 3.75H8.625C9.65887 3.75 10.5 2.90887 10.5 1.875C10.5 0.841125 9.65887 0 8.625 0H7.375C6.56022 0 5.86553 0.522563 5.6075 1.25H3.625C2.59113 1.25 1.75 2.09113 1.75 3.125V14.125C1.75 15.1589 2.59113 16 3.625 16H12.375C13.4089 16 14.25 15.1589 14.25 14.125V3.125C14.25 2.09113 13.4089 1.25 12.375 1.25ZM7.375 1.25H8.625C8.96962 1.25 9.25 1.53038 9.25 1.875C9.25 2.21962 8.96962 2.5 8.625 2.5H7.375C7.03038 2.5 6.75 2.21962 6.75 1.875C6.75 1.53038 7.03038 1.25 7.375 1.25Z",
    fill: "#3F4752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.4d419b36f41413398ab15c39b4910f08.svg";
export { ForwardRef as ReactComponent };